export {
  STEP1_CATEGORY_DECISION,
  STEP1_CATEGORY_TYPE,
  TRANSITION_TIMEOUT,
} from '../constant';

export const DECISION_DONE = 'Done';
export const DECISION_TOTAL = 'Total';
export const DECISION_PROGRESS = 'Progress';
export const DECISION_PENDING = 'Pending';

export const DECISION_ICONS = {
  NoActionRequired: 'Reject',
  Done: 'Check',
  Progress: 'Check',
  Pending: 'Consult',
  Approved: 'Check',
  Rejected: 'Reject',
  Total: 'Reject',
  Terminated: 'Terminate',
  Reassigned: 'Reassign',
  'Manager Confirmed With End Date Changed': 'ConfirmManager',
  'End Date Changed': 'ExtendEndDate',
  'Not Confirmed By Manager': 'NotConfirmedByManager',
  Revoked: 'Revoked',
  Consult: 'Consult',
  'Manager Confirmed': 'ConfirmManager',
  'Conditionally Certified': 'ExtendEndDate',
  'Does Not Belong To Me': 'Reassign',
  'Does Not Belong': 'Reassign',
  Decommissioned: 'Reject',
};

export const DECISION_TITLES = {
  NoActionRequired: 'No Action Required',
  Done: 'Done',
  Progress: 'Progress',
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Total: 'Total',
  Terminated: 'Terminated',
  Reassigned: 'Reassigned',
  'End Date Changed': 'End Date Changed',
  'Not Confirmed By Manager': 'Not Confirmed By Manager',
  'Manager Confirmed With End Date Changed':
    'Manager Confirmed With End Date Changed',
  'Manager Confirmed': 'Manager Confirmed',
  'Conditionally Certified': 'Conditionally Certified',
};

export const TYPE_ICONS = {
  Role: 'Role',
  Account: 'Account',
  User: 'User',
  Entitlement: 'Entitlement',
  ParentEnt: 'Entitlement',
  ChildEntitlement: 'Entitlement',
};

export const TYPE_TITLES_AND_ORDER = {
  User: 'User',
  Account: 'Account',
  Role: 'Role',
  Entitlement: 'Entitlement',
};

export const EO_TYPE_TITLES_AND_ORDER = {
  ParentEnt: 'Entitlement',
  Account: 'Account',
  ChildEntitlement: 'Child Entitlement',
};

export const DECISION_TITLES_AND_ORDER = {
  'Manager Confirmed': 0,
  ManagerConfirmed: 0,
  'Manager Confirmed With End Date Changed': 1,
  ManagerConfirmedWithEndDateChanged: 1,
  'Not Confirmed By Manager': 2,
  Terminated: 3,
  Approved: 4,
  Rejected: 5,
  'End Date Changed': 6,
  EndDateChanged: 6,
  'Conditionally Certified': 7,
  ConditionallyCertified: 7,
  Reassigned: 8,
  'No Action Required': 9,
  NoActionRequired: 9,
};
